//const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_API_VERSION}`;
const API_DESCARGAS_BASE_URL = `${process.env.REACT_APP_DESCARGAS_URL}/Comprobante`;

//const ASPIRANTE_URL = `${API_BASE_URL}/Persona`;

//ESTABLECIMIENTO
const OFERTA_BASE_URL = `${API_BASE_URL}/Oferta`;
const ESTABLECIMIENTO_URL = `${OFERTA_BASE_URL}/GetOfertasAsync`;
const ESTABLECIMIENTO_PASO4_URL = `${API_BASE_URL}/Establecimiento/GetEstablecimientosAsync`;
const ESTABLECIMIENTOANTERIOR_PASO4_URL = `${API_BASE_URL}/Establecimiento/GetEstablecimientosAnteriorAsync`;

//PASO 1
const INSCRIPCION_PASO_UNO_AL_DOS_URL=API_BASE_URL+"/Inscripcion/GuardarPaso1YObtenerPaso2Async";
const INSCRIPCION_PASO_UNO_AL_CERO_URL=API_BASE_URL+"/Inscripcion/PersistStep1AndGoToStep0";
//PASO 2
const INSCRIPCION_PASO_DOS_AL_UNO_URL=API_BASE_URL+"/Inscripcion/PersistStep2AndGoToStep1";
const INSCRIPCION_PASO_DOS_AL_TRES_URL=API_BASE_URL+"/Inscripcion/GuardarPaso2YObtenerPaso3Async";
//PASO 3
const INSCRIPCION_PASO_TRES_AL_DOS_URL=API_BASE_URL+"/Inscripcion/PersistStep3AndGoToStep2";
const INSCRIPCION_PASO_TRES_AL_CUATRO_URL=API_BASE_URL+"/Inscripcion/GuardarPaso3YObtenerPaso4Async";
//PASO4
const INSCRIPCION_PASO_CUATRO_AL_TRES_URL=API_BASE_URL+"/Inscripcion/PersistStep4AndGoToStep3";
const INSCRIPCION_PASO_CUATRO_AL_CINCO_URL=API_BASE_URL+"/Inscripcion/GuardarPaso4YObtenerPaso5Async";

//PASO 5
const INSCRIPCION_PASO_CINCO_URL=API_BASE_URL+"/Inscripcion/Finalizar";

//Llamados
const LLAMADOS_URL = `${API_BASE_URL}/Llamado/GetLlamadosAsync`;
const DESCARGAR_CONSTANCIA_URL = `${API_DESCARGAS_BASE_URL}/DescargarComprobante`;

//Inscripciones
const INSCRIPCIONES_BASE_URL = `${API_BASE_URL}/Inscripcion`;
const INSCRIPCIONES_URL = `${INSCRIPCIONES_BASE_URL}/GetInscripcionesAsync`;
const DELETE_INSCRIPCION_URL = `${INSCRIPCIONES_BASE_URL}/Descartar`;

//INSCRIPCION ASYNC
const INSCRIPCION_ASYNC_URL=`${API_BASE_URL}/Inscripcion/GetPaso1Async`

//RESPONSABLE
//const RESPONSABLE_URL=`${API_BASE_URL}/Responsable`;

//BUSCAR HERMANO/FAMILIAR
const PERSONA_BASE_URL=`${API_BASE_URL}/Persona`;
const PERSONA_URL=`${PERSONA_BASE_URL}/GetBy`;

export {
    //ASPIRANTE
    //ASPIRANTE_URL,

    //PASO 1 A OTROS
    INSCRIPCION_PASO_UNO_AL_DOS_URL,
    INSCRIPCION_PASO_UNO_AL_CERO_URL,

    //PASO 2 A OTROS
    INSCRIPCION_PASO_DOS_AL_UNO_URL,
    INSCRIPCION_PASO_DOS_AL_TRES_URL,

    //PASO 3 A OTROS
    INSCRIPCION_PASO_TRES_AL_DOS_URL,
    INSCRIPCION_PASO_TRES_AL_CUATRO_URL,
    
    //PASO 4 A OTROS
    INSCRIPCION_PASO_CUATRO_AL_TRES_URL,
    INSCRIPCION_PASO_CUATRO_AL_CINCO_URL,

    INSCRIPCION_PASO_CINCO_URL,

    //Llamados
    LLAMADOS_URL,
    DESCARGAR_CONSTANCIA_URL,
    
    //Inscripiones
    INSCRIPCIONES_URL,
    DELETE_INSCRIPCION_URL,
    
    //INSCRIPCION ASYNC
    INSCRIPCION_ASYNC_URL,

    //RESPONSABLE
    //RESPONSABLE_URL,

    //ESTABLECIMIENTO
    ESTABLECIMIENTO_URL,
    ESTABLECIMIENTO_PASO4_URL,
    ESTABLECIMIENTOANTERIOR_PASO4_URL,
    
    PERSONA_URL
}